//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebaseHelper"

// action
import {
    profileSuccess, profileError
} from "./reducer";

import {
    postFakeProfile,
    postJwtProfile,
} from "../../../helpers/fakebackendHelper"
import axios from "axios";
import axiosInstance from "src/common/axiosInstance";

const fireBaseBackend = getFirebaseBackend()

export const editProfile: any = (user: any) => async (dispatch: any) => {
    try {
        const config = {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
        };
        const response = await axiosInstance.post(`/update-profile`, user, config);
        const data = await response.data;
        if (!data.data.exists) {
            dispatch(profileSuccess(data.data.user))
        }
        return response.data;
    } catch (error) {
        dispatch(profileError(error))
        return error;
    }
};

export const resetProfileFlag = (user: any) => async (dispatch: any) => {

}
